export const uk = {
    'expander-error': 'Прогноз временно недоступен',
    'expander-header': 'Добавьте баннеры',
    'expander-no-data': 'Отключите или расширьте некоторые характеристики профиля пользователей',
    increase: 'Увеличить охват'
};
